/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.ExerciseChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getRequirementsRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.ExerciseChirpService',
  rpcName: 'getRequirements',
  auth: 'app',
  fingerprint: 'SEFm2rYGuvoSmK7fcfnLUpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};